const trimTrailingSlash = (value) => value.replace(/\/+$/, "");

export const getApiBaseUrl = () => {
  const configured = process.env.REACT_APP_API_URL;

  if (configured && configured.trim()) {
    return trimTrailingSlash(configured.trim());
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return trimTrailingSlash(window.location.origin);
  }

  return "";
};
